<template>
  <div>
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="赠品类型" slot="giftType" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.giftType == "01" ? "换新补贴" : "回收赠礼" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="赠品价值/最高补贴"
        slot="giftPrice"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ row.giftPrice || 0}}元
        </template>
      </el-table-column>
      <el-table-column label="订单发放记录" slot="giftIssueNum" align="center">
        <template slot-scope="{ row }">
          <div
            style="text-decoration: underline; cursor: pointer; color: #0981ff"
            @click="allInFn(row)"
            v-if="row.giftIssueNum"
            >{{ row.giftIssueNum }}</div
          >
          <span v-else>{{ row.giftIssueNum || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column width="250" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="editGif(row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <el-dialog
      class="add-form"
      title="编辑赠品"
      :visible.sync="addShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="addDialogClose"
    >
      <el-form
        :model="formDataDialog"
        :rules="formRulesDialog"
        ref="ruleForm"
        label-width="106px"
      >
        <el-form-item label="赠品名称" prop="giftName">
          <el-input
            size="small"
            v-model="formDataDialog.giftName"
            placeholder="请输入赠品名称（20字内）"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="赠品类型" required>
          <el-radio-group v-model="formDataDialog.giftType" disabled>
            <el-radio label="01">换新补贴</el-radio>
            <el-radio label="02">回收赠礼</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="活动最高补贴"
          v-if="formDataDialog.giftType == '01'"
          prop="giftPrice"
        >
          <el-input
            size="small"
            placeholder="请输入正整数"
            v-model.trim="formDataDialog.giftPrice"
            @input="formDataDialog.giftPrice=formDataDialog.giftPrice.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="赠品价值"
          v-if="formDataDialog.giftType == '02'"
          prop="giftPrice"
        >
          <el-input
            size="small"
            placeholder="请输入正整数"
            v-model.trim="formDataDialog.giftPrice"
            @input="formDataDialog.giftPrice=formDataDialog.giftPrice.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="formDataDialog.giftType == '01' ? '换新活动海报' : '赠品介绍'"
        >
          <div style="display:flex;">
            <ElImgUpload
              :exist-image="formDataDialog.giftPosters"
              @handleDelete="handleUploadDelete"
              @handleChange="handleUploadChange($event)"
            />
            <span
              style="text-decoration: underline; cursor: pointer; color: #0981ff;margin-left:20px"
              @click="seeExample"
              >查看示例</span
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addShow = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="submitAdd"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <DialogTbale
      :show="dialogTableShow"
      title="发放记录"
      :loading="dialogTableLoading"
      :columns="DialogTableColumns"
      :data="DialogDataList"
      :currentPage="pageDialog.pageNum"
      :total="pageDialog.total"
      :pageSize="pageDialog.pageSize"
      :width="1000"
      @onClose="dialogTbaleClose"
      @handleCurrentChange="handleCurrentChangeDialog"
    >
      <div style="display:flex">
        <el-form :inline="true" :model="issueRecordForm">
          <el-form-item label="门店名称">
            <el-input
              size="small"
              v-model="issueRecordForm.storeName"
              placeholder="请输入门店名称"
              class="form_input"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="成交时间">
            <el-date-picker
              v-model="valueTime"
              type="daterange"
              size="small"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleCurrentChangeDialog(1)" size="mini"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table-column label="下单顾客" slot="userName" align="center">
        <template slot-scope="{ row }">
          <span>{{row.userName?row.userName+'-':''}}{{row.userMobile}}</span>
        </template>
      </el-table-column>
      <el-table-column label="受理店员" slot="staffName" align="center">
        <template slot-scope="{ row }">
          <span>{{row.staffName?row.staffName+'-':''}}{{row.staffMobile}}</span>
        </template>
      </el-table-column>
      <el-table-column label="线上订单" slot="customerOrderNo" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.customerOrderNo" style="text-decoration: underline; cursor: pointer; color: #0981ff" @click="toLink(row.customerOrderNo,'on')">{{row.customerOrderNo}}</div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="回收订单" slot="recycleOrderNo" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.recycleOrderNo" style="text-decoration: underline; cursor: pointer; color: #0981ff" @click="toLink(row.recycleOrderNo,'recycle')">{{row.recycleOrderNo}}</div>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </DialogTbale>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import ElImgUpload from "../../../components/global/components/elements/upload-element";

export default {
  components: { ElImgUpload },
  data() {
    return {
      tableColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
        { slotName: "giftIssueNum" },
        { label: "创建时间", prop: "createTime" },
        { slotName: "operation" },
      ],
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pageDialog: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      addShow: false,
      btnLoading: false,
      formDataDialog: {
        giftName: "",
        giftType: "01",
        giftPrice: "",
        giftPosters: "",
      },
      formRulesDialog: {
        giftName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入赠品名称",
          },
        ],
        giftPrice: [
          {
            required: true,
            trigger: "blur",
            message: "金额不能为空",
          },
        ],
      },
      dialogTableShow: false,
      dialogTableLoading: false,
      DialogTableColumns:[
        { slotName: "userName" },
        { label: "核销门店", prop: "hxStoreName" },
        { label: "成交时间", prop: "finishTime" },
        { slotName: "staffName" },
        { slotName: "customerOrderNo" },
        { slotName: "recycleOrderNo" },
      ],
      issueRecordForm: {
        storeName: "",
      },
      valueTime: "",
      DialogDataList:[],
    };
  },
  created() {
    this.handleCurrentChange();
  },
  mounted() {},
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange(1);
    },
  },
  methods: {
    // 订单编号跳转详情
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    //   切换页
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        giftName: this.SeachParams.giftName,
        giftType: this.SeachParams.giftType,
        startTime: this.SeachParams.startTime || "",
        endTime: this.SeachParams.endTime || "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.giftList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    editGif(row) {
      this.addShow = true;
      this.rowId = row.id;
      this.formDataDialog = {
        giftName: row.giftName,
        giftType: row.giftType,
        giftPrice: row.giftPrice,
        giftPosters: row.giftPosters,
      };
    },
    // 确认添加
    submitAdd() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          _api
            .addOrUpdate({ id: this.rowId, ...this.formDataDialog })
            .then((res) => {
              console.log(res);
              if (res.code === 1) {
                this.$message.success(res.msg);
                this.addShow = false;
                this.handleCurrentChange();
                this.$refs["ruleForm"].resetFields();
                this.addShow = false;
              }
              this.btnLoading = false;
            })
            .catch(() => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    //删除图片
    handleUploadDelete() {
      this.formDataDialog.giftPosters = "";
    },
    // 上传图片后，将图片信息保存到对应参数中
    handleUploadChange(url) {
      this.formDataDialog.giftPosters = url;
    },
    addDialogClose() {
      this.formDataDialog = {
        giftName: "",
        giftType: "01",
        giftPrice: "",
      };
      this.$refs["ruleForm"].resetFields();
    },
    // 关闭发放记录弹框
    dialogTbaleClose() {
      this.dialogTableShow = false
      this.valueTime = ""
      this.issueRecordForm.storeName = ''
    },
    allInFn(row) {
      this.rowId = row.id
      this.dialogTableShow = true
      this.handleCurrentChangeDialog(1)
    },
    // 发放记录弹框翻页
    handleCurrentChangeDialog(val) {
      if (val) {
        this.pageDialog.pageNum = val;
      }
      const baseRequest = {
        giftId: this.rowId,
        storeName: this.issueRecordForm.storeName,
        startTime: this.valueTime && this.valueTime[0] || "",
        endTime: this.valueTime && this.valueTime[1] || "",
        pageNum: this.pageDialog.pageNum,
        pageSize: this.pageDialog.pageSize,
      };
      this.dialogTableLoading = true;
      _api.issueRecord(baseRequest).then((res) => {
        if (res.code === 1) {
          this.DialogDataList = res.data.records;
          this.pageDialog.total = res.data.total;
          this.pageDialog.pageNum = res.data.current;
          this.dialogTableLoading = false;
        }
      });
    },
    // 详情
    toLink(orderNo,type) {
      if(type == 'on') {
        let routeData = this.$router.resolve({
          path: "/OnlinreyService/OrderDetails",
          query: {
            orderNo,
          },
        });
        window.open(routeData.href, "_blank");
      }else if(type == 'recycle'){
        let routeData = this.$router.resolve({
          path: "/RecallOrder/Details",
          query: { type: "edit", id: orderNo },
        });
        window.open(routeData.href, "_blank");
      }
      
    },
    seeExample(){
      this.$emit("seeExample",this.formDataDialog.giftType)
    }
  },
};
</script>

<style lang="scss" scoped>
.add-form {
  /deep/.el-input-group__append {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  // /deep/.el-form-item {
  //   margin-bottom: 10px;
  // }
  /deep/.el-form-item__content .el-input-group {
    vertical-align: middle;
  }
}
/deep/ .form_input .el-input__inner{
    height: 30px!important;
  }
</style>
